// deps
import React, { ReactElement, memo } from "react";

//components
import { LinkAccountPhoneNumberV4 } from "./v4";

export interface LinkAccountPhoneNumberProps {
    onConfirmLinking: (mobileNumber: string) => void;
    iconUrl: string;
    displayName: string;
    editableState: { isEditable: boolean; registeredMobileNumber: string };
    mobileNumber: string;
    setMobileNumber: (mobileNumber: string) => void;
}

function LinkAccountPhoneNumber(props: LinkAccountPhoneNumberProps): ReactElement {
    return <LinkAccountPhoneNumberV4 {...props} />;
}
export default memo(LinkAccountPhoneNumber);
